import {User} from '../types/User';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class UsersService {
  public async getAllUsers(): Promise<User[]> {
    return handleError(
      () => httpClient.get<User[]>('/users'),
      'Error fetching users:',
      () => []
    );
  }

  public async getUser(id: string): Promise<User> {
    return handleError(
      () => httpClient.get<User>(`/users/${id}`),
      'Error fetching user:'
    );
  }

  public async updateUser(user: User): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/users/${user.id}`, {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        role: user.role
      }),
      'Error updating user:'
    );
  }

  public async disableUser(id: string): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/users/${id}/disable`),
      'Error disabling user:'
    );
  }
}

const usersService = new UsersService();
export default usersService;

